import { render, staticRenderFns } from "./ChaoMaiStores.vue?vue&type=template&id=fa08ecea&scoped=true"
import script from "./ChaoMaiStores.vue?vue&type=script&lang=js"
export * from "./ChaoMaiStores.vue?vue&type=script&lang=js"
import style0 from "./ChaoMaiStores.vue?vue&type=style&index=0&id=fa08ecea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08ecea",
  null
  
)

export default component.exports